import './src/styles/global.css';
import smoothscroll from 'smoothscroll-polyfill';
import './webview';

smoothscroll.polyfill();
